import { Dictionary } from "../../Utilities";

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class IFrameCommManager {
    private static _postMessage: (message: string) => void;

    public static watchers: Dictionary<
        string,
        (moduleId: number, message: string) => void
    >;

    private static _resetSectionState: () => void;

    public static initialize(): void {
        if (
            IFrameCommManager.watchers === null ||
            typeof IFrameCommManager.watchers === `undefined`
        ) {
            IFrameCommManager.watchers = new Dictionary();
        }
    }

    public static messageListener(
        moduleId: number,
        recievedMessage: MessageEvent,
    ): void {
        if (typeof recievedMessage.data === `string`) {
            if (recievedMessage.data.includes(`ViewShare:`)) {
                const messageText: string = recievedMessage.data.replace(
                    `ViewShare:`,
                    ``,
                );

                IFrameCommManager.watchers.forEach(
                    (
                        key: string,
                        value: (moduleId: number, message: string) => void,
                    ) => {
                        value(moduleId, messageText);
                    },
                );
            }
        }
    }

    public static registerOrUpdateToolFrame(
        postMessage: (message: string) => void,
    ): void {
        IFrameCommManager._postMessage = postMessage;
    }

    public static deRegisterToolFrame(): void {
        IFrameCommManager._postMessage = null;
    }

    public static registerOrUpdateWatcher(
        watcherKey: string,
        watcher: (moduleId: number, message: string) => void,
    ): void {
        if (IFrameCommManager.watchers.contains(watcherKey)) {
            IFrameCommManager.watchers.set(watcherKey, watcher);
        } else {
            IFrameCommManager.watchers.push(watcherKey, watcher);
        }
    }

    public static deRegisterWatcher(watcherKey: string): void {
        IFrameCommManager.watchers.remove(watcherKey);
    }

    public static registerOrUpdateResetState(checkFunction: () => void): void {
        IFrameCommManager._resetSectionState = checkFunction;
    }

    public static deRegisterResetState(): void {
        IFrameCommManager._resetSectionState = null;
    }

    public static messageTool(message: string): void {
        IFrameCommManager._postMessage(`ViewShare:${message}`);
    }

    public static resetState(): void {
        if (IFrameCommManager._resetSectionState) {
            IFrameCommManager._resetSectionState();
        }
    }
}
